import { render, staticRenderFns } from "./SlideoutReview.vue?vue&type=template&id=32b93816&"
import script from "./SlideoutReview.vue?vue&type=script&lang=js&"
export * from "./SlideoutReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b93816')) {
      api.createRecord('32b93816', component.options)
    } else {
      api.reload('32b93816', component.options)
    }
    module.hot.accept("./SlideoutReview.vue?vue&type=template&id=32b93816&", function () {
      api.rerender('32b93816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/SlideoutReview.vue"
export default component.exports